import { EVENT } from '@/analytics';
import ZenDeskScript from '@/head/ZenDesk';
import React, {
  createContext,
  SetStateAction,
  Dispatch,
  useState,
  ReactNode,
  useEffect,
  useCallback,
} from 'react';
import mixpanel from 'mixpanel-browser';
import { useFeatureFlag } from '@/store';
import flags from '@/store/flags';
/**
 * The Help Popup Context
 */
export const HelpPopupContext = createContext<boolean>(false);

export const HelpPopupDispatchContext = createContext<Dispatch<SetStateAction<boolean>>>(undefined);

export const HelpPopupOpenChatContext = createContext<() => void>(undefined);
declare let zE: any;

export function HelpPopupProvider({ children }: { children: ReactNode }) {
  const [helpPopupOpen, _sethelpPopupOpen] = useState(false);

  const helphubEnabled = useFeatureFlag(flags.Helphub);

  useEffect(() => {
    // Inserts a callback to commandbar to open the Zendesk support widget
    window.CommandBar?.addCallback('openZendesk', () => {
      zE('messenger', 'open');
      mixpanel.track(EVENT.USED_HELP_RESOURCES, {
        help_resources: 'get_support',
      });
    });
  }, []);

  const sethelpPopupOpen = useCallback(
    (open: boolean) => {
      // If command bar is not loaded, open the legacy help popup
      if (!window.CommandBar || !helphubEnabled) {
        _sethelpPopupOpen(open);
        return;
      }

      // Otherwise, open commandbar
      if (open) {
        window.CommandBar.openHelpHub();
      } else {
        window.CommandBar.closeHelpHub();
      }
    },
    [helphubEnabled]
  );

  const openHelpChat = useCallback(() => {
    zE('messenger', 'open');
    mixpanel.track(EVENT.USED_HELP_RESOURCES, { help_resources: 'get_support' });
  }, []);

  return (
    <HelpPopupContext.Provider value={helpPopupOpen}>
      <HelpPopupDispatchContext.Provider value={sethelpPopupOpen}>
        <HelpPopupOpenChatContext.Provider value={openHelpChat}>
          <ZenDeskScript />
          {children}
        </HelpPopupOpenChatContext.Provider>
      </HelpPopupDispatchContext.Provider>
    </HelpPopupContext.Provider>
  );
}
